<script>
import CallbackButton from "@js/components/Buttons/CallbackButton.vue";
import CatalogButton from "@js/components/Buttons/CatalogButton.vue";
import ServicesTopForm from "@js/components/Sections/Callback/ServicesTopForm.vue";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";

export default {
    name: "ServicesTopComponent",
    components: {Breadcrumbs, OnlyDesktop, ServicesTopForm, CatalogButton, CallbackButton}
}
</script>

<template>
    <div
        class="relative ling-bg flex justify-center md:items-center items-start text-center bg-[url('@img/backgrounds/services/sm.svg')] md:bg-[url('@img/backgrounds/services/lg.svg')] bg-no-repeat bg-90%  md:bg-contain bg-right-bottom md:bg-right-top bg-img pt-10 mb-10 md:mb-20">
        <div class="container">
            <div class=" grid grid-cols-1 md:grid-cols-2 gap-4">
                <div class="text-left mb-10 md:mb-0">
                    <Breadcrumbs class="mb-2"/>
                    <h1 class="text-2xl md:text-4xl font-bold text-black">
                        Комплексное решение для вашего объекта
                    </h1>
                    <ul class="max-w-xl space-y-5 list-disc list-outside text-black text-sm md:text-base mt-8 ms-5 font-medium">
                        <li>
                            Поставка и продажа дорожных плит – широкий ассортимент плит различных типов и размеров с
                            гарантией качества.
                        </li>
                        <li>
                            Доставка и выгрузка на объект – собственный автопарк (манипуляторы, краны, бортовые машины) для
                            быстрой и безопасной транспортировки.
                        </li>
                        <li>
                            Монтаж и укладка плит – профессиональная укладка дорожных плит с соблюдением всех строительных
                            норм и технологий.
                        </li>
                        <li class="hidden md:list-item">
                            Демонтаж и утилизация – разборка, вывоз и переработка старых бетонных покрытий с минимальными
                            затратами для клиента.
                        </li>
                    </ul>
                    <OnlyDesktop>
                        <div class="block md:inline-flex items-center gap-5 mt-10">
                            <CallbackButton class="w-full md:w-auto"/>
                            <CatalogButton class="mt-5 md:mt-0 w-full md:w-auto"
                                           :isBlurry="true"
                                           :dark="true"/>
                        </div>
                    </OnlyDesktop>
                </div>
                <div class="flex justify-center">
                    <ServicesTopForm/>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
